//fichier CSS principal
import style from "./styles/style.scss";

/* BUBBLES */
import bubblecss from "bubbles/dist/main.css";
import bubbleCalcul from "bubbles/dist/main";